module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.9@core-js/library/modules/_redefine.js
// module id = 39
// module chunks = 0